import BusinessesList from '@/components/businesses/BusinessesList';
import {
  SVButton,
  SVListFilters,
  SVListPagination,
  SVListStats,
  SVLoader,
} from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { FILTERS } from '@/constants/filters';
import { ROUTES } from '@/constants/routes';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { useGetBusinessesList } from '@/hooks/requests/useBusinesses';
import { formatCurrency } from '@/utils/currency';
import { Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function BusinessesListPage() {
  const navigate = useNavigate();
  const {
    businesses,
    aggregateInfo,
    totalRecordCount,
    isBusinessesPending,
    isSuccess,
  } = useGetBusinessesList();

  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.STATUS],
    hasCompanyFilter: true,
    hasTeammateFilter: true,
  });
  const stats = {
    'Total Members': aggregateInfo?.totalMembers ?? 0,
    'Total Bank Accounts': aggregateInfo?.totalActiveBankAccounts ?? 0,
    'Total Available Balance': formatCurrency({
      amount: aggregateInfo?.totalAvailableBalance.value ?? 0,
    }),
  };

  return (
    <DefaultLayout
      header={`Businesses ${totalRecordCount ? `(${totalRecordCount})` : ''}`}
      buttons={[
        <SVButton
          onClick={() => navigate(ROUTES.BUSINESSES_ADD)}
          fullWidth
          key="add"
          aria-label="Add Business">
          Add
        </SVButton>,
      ]}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by Business Name"
      />
      {isBusinessesPending ? (
        <SVLoader />
      ) : (
        <>
          {businesses.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              {aggregateInfo && <SVListStats stats={stats} />}
              <BusinessesList businesses={businesses} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
